import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@src/store/index';

type State = { bizSkills: string[] };

const initialState: State = { bizSkills: [] };

const bizSkillsSlice = createSlice({
  name: 'bizSkill',
  initialState,
  reducers: {
    addBizSkill(state, action: PayloadAction<string>) {
      state.bizSkills.push(action.payload);
    },
    updateBizSkill(state, action: PayloadAction<{ index: number; item: string }>) {
      const { index, item } = action.payload;
      if (index >= 0 && index < state.bizSkills.length) {
        state.bizSkills[index] = item;
      }
    },
    updateBizSkillsFromStorage(state, action: PayloadAction<string[]>) {
      state.bizSkills = action.payload;
    },
    removeBizSkill(state, action: PayloadAction<number>) {
      state.bizSkills.splice(action.payload, 1);
    },
  },
});

export const { addBizSkill, updateBizSkill, updateBizSkillsFromStorage, removeBizSkill } =
  bizSkillsSlice.actions;

export const selectBizSkill = (state: RootState): string[] => state.bizSkill.bizSkills;

export default bizSkillsSlice.reducer;
